import LightningIcon from './component'

export default LightningIcon
